const focusButton = (buttonRef) => {
  buttonRef.current?.focus();
  buttonRef.current?.setAttribute("tabIndex", "0");
};

const navigateFromSubtitleToCheckboxes = (
  activeElement,
  e
) => {
  const notificationSubtitle = document.querySelector(".notification-settings-subtitle");
  if (!notificationSubtitle || activeElement !== notificationSubtitle) return;

  if (!e.shiftKey) {
    e.preventDefault();
    const formWrapper = document.querySelector(".form-wrapper");
    if (formWrapper) {
      const firstCheckbox = formWrapper.querySelector('input[type="checkbox"]');
      firstCheckbox?.focus();
    }
  }
};

const navigateFromCheckboxesToButtons = (
  activeElement,
  e,
  saveButtonRef
) => {
  const formWrapper = document.querySelector(".form-wrapper");
  if (!formWrapper || !formWrapper.contains(activeElement)) return;

  const allCheckboxes = Array.from(formWrapper.querySelectorAll('input[type="checkbox"]'));
  const lastCheckbox = allCheckboxes[allCheckboxes.length - 1];
  const firstCheckbox = allCheckboxes[0];

  if (activeElement === lastCheckbox && !e.shiftKey) {
    e.preventDefault();
    focusButton(saveButtonRef);
  }

  if (activeElement === firstCheckbox && e.shiftKey) {
    e.preventDefault();
    const notificationSubtitle = document.querySelector(".notification-settings-subtitle");
    notificationSubtitle?.focus();
  }
};

const navigateBetweenButtons = (
  activeElement,
  e,
  saveButtonRef,
  clearButtonRef
) => {
  // Check if active element is one of the buttons using refs
  const isSaveButton = activeElement === saveButtonRef.current;
  const isClearButton = activeElement === clearButtonRef.current;

  if (!isSaveButton && !isClearButton) return;

  // Save -> Clear All (forward)
  if (isSaveButton && !e.shiftKey) {
    e.preventDefault();
    focusButton(clearButtonRef);
  }

  // Clear All -> Save (backward)
  if (isClearButton && e.shiftKey) {
    e.preventDefault();
    focusButton(saveButtonRef);
  }

  // Save -> last checkbox (backward)
  if (isSaveButton && e.shiftKey) {
    e.preventDefault();
    const formWrapper = document.querySelector(".form-wrapper");
    if (formWrapper) {
      const allCheckboxes = Array.from(formWrapper.querySelectorAll('input[type="checkbox"]'));
      const lastCheckbox = allCheckboxes[allCheckboxes.length - 1];
      lastCheckbox?.focus();
    }
  }

  // Clear All -> h2 subtitle (forward) - closes the loop
  if (isClearButton && !e.shiftKey) {
    e.preventDefault();
    const notificationSubtitle = document.querySelector(".notification-settings-subtitle");
    notificationSubtitle?.focus();
  }
};

export const createKeyboardNavigation = ({
  saveButtonRef,
  clearButtonRef
}) => {
  const handleTabKeyNavigation = e => {
    if (e.key !== "Tab") return;

    const activeElement = document.activeElement;

    navigateFromSubtitleToCheckboxes(activeElement, e);

    navigateFromCheckboxesToButtons(
      activeElement,
      e,
      saveButtonRef
    );

    navigateBetweenButtons(
      activeElement,
      e,
      saveButtonRef,
      clearButtonRef
    );
  };

  const setupTabNavigation = () => {
    document.addEventListener("keydown", handleTabKeyNavigation);

    const handleFocusOut = e => {
      const notificationHeader = document.querySelector(".notification-settings-header");
      if (notificationHeader && !notificationHeader.contains(e.relatedTarget)) {
        const saveButton = document.querySelector("#save-notification-button");
        const clearButton = document.querySelector("#clear-all-button");
        if (saveButton) {
          saveButton.setAttribute("tabIndex", "-1");
        }
        if (clearButton) {
          clearButton.setAttribute("tabIndex", "-1");
        }
      }
    };

    document.addEventListener("focusout", handleFocusOut);

    return () => {
      document.removeEventListener("keydown", handleTabKeyNavigation);
      document.removeEventListener("focusout", handleFocusOut);
    };
  };

  return {
    handleTabKeyNavigation,
    setupTabNavigation
  };
};

